import React from 'react';
import '../../styles/styles.scss';
import { FormattedMessage } from 'react-intl';

export default class Footer extends React.Component {

  render () {
    const showGdpr = localStorage.getItem('GDPR');
    return (
      <>
        {(!showGdpr || showGdpr === 'true') &&
          <div className="gdpr">
            <p className="close" onClick={() => this.closeDialog()}>x</p>
            <div className="medium">
              <FormattedMessage id="app.feedback.gdpr.message" />
            </div>
          </div>}
      </>
    );
  };

  closeDialog = () => {
    localStorage.setItem('GDPR', false);
    this.forceUpdate();
  }
}
